module.exports = __webpack_public_path__ + "img/6.1a23d5ff.jpg";